import React from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import './RevealPasswordModal.scss';
import { Tooltip } from '@mui/material';
import SnackbarUtils from '../../../utils/SnackbarUtils';

const RevealPasswordModal = props => {
  const handleClose = data => {
    props.onClose({ ...data, payload: props.payload });
  };

  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(props.password);
      SnackbarUtils.info('Password has been copied to your clipboard!');
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <ModalHeader toggle={handleClose}>Reveal password</ModalHeader>
      <ModalBody>
        <div className={'d-flex justify-content-end mb-1'}>
          <Tooltip title='Copy to clipboard' arrow>
            <span>
              <Button color='info' type='button' onClick={copyToClipBoard}>
                <i className={'fa fa-file-import'}></i>
              </Button>
            </span>
          </Tooltip>
        </div>
        <div className={'code-container'}>{props.password}</div>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={handleClose}>
          Cancel
        </Button>
      </ModalFooter>
    </>
  );
};

export default React.memo(RevealPasswordModal);
RevealPasswordModal.whyDidYouRender = true;
